import InfoIcon from "@mui/icons-material/Info";
import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import supportContent from "./content/supportcontent";
import Divider from "@mui/material/Divider";
import HelpIcon from '@mui/icons-material/Help';
import { camelCaseToSpaceDelimited } from "../../helpers/DataUpdateHelper";
import Button from "@mui/material/Button";

interface InfoButtonProps {
  type: string;
  flavor: string;
  float?: boolean
}

const InfoButton = (props: InfoButtonProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const content = supportContent[props.type];

  let  displayedIcon = <InfoIcon style={{ color: "#1976d2", marginBottom: "-5px" }} />
  if(props.flavor=='help'){
    displayedIcon =  <HelpIcon style={{ color: "#1976d2", marginBottom: "-5px"  }} />

  }

  const stylingFloat =  props.float  ? "right" : "none";
  return (
    <span onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
      {displayedIcon}
      <Popover
        PaperProps={{
          style: { width: "400px", border: "2pt solid #1976d2" },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Button  style={{float:"right"}} onClick={handlePopoverClose}>x</Button>
        <Typography sx={{ p: 2, color: "#1976d2" }}>
          <h3>
            <span style={{width:"200px",wordWrap:"break-word", overflowWrap:"break-word"}}>  {camelCaseToSpaceDelimited(props.type)}</span>
            <span style={{position:"absolute", right:15, top:50, zIndex: 5000 }}>
              <InfoIcon
                style={{
                  color: "#1976d2",
                  marginTop: "-20px",
                  fontSize: "30pt",
                  float:stylingFloat
                }}
              />
            </span>
          </h3>
          <Divider />
          <br />
          {content}
        </Typography>
      </Popover>
    </span>
  );
};

export default InfoButton;
